import { setLoadingConfigObject } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './HeaderLoading.config.style';

const headerLoadingConfig = loaderStyle => [
  {
    left: setLoadingConfigObject('circle', 1, null, [styles.title, loaderStyle]),
  },
];

export { headerLoadingConfig }; // eslint-disable-line import/prefer-default-export
